let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3nfxN")).then(() => parcelRequire('840FM'));